import React from "react";

export default function BleAudioIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                fill="#231F20"
                d="M16 0v31.172L1.414 17.585 0 19l15.406 14.5L0 48l1.414 1.414L16 35.828V67l18-18-15.5-15.5L34 18 16 0zm2 4.828L31.171 18l-13.17 13.172V4.828zm0 31L31.171 49l-13.17 13.171V35.828zM54 20.144L52 20.144 52 6.473 51 5.606 50 6.473 50 20.144 48 20.144 48 5.682 51 2.682 54 5.682z"
                transform="translate(-920 -1240) translate(920 1240) translate(4 7)"
              />
              <path
                fill="#231F20"
                d="M48.5 11.644L53.5 11.644 53.5 9.644 48.5 9.644zM48.5 15.644L53.5 15.644 53.5 13.644 48.5 13.644z"
                transform="translate(-920 -1240) translate(920 1240) translate(4 7)"
              />
              <path
                stroke="#231F20"
                strokeWidth="2"
                d="M48 20.644L48 34.644 49 34.644 49 42.644 53 42.644 53 34.644 54 34.644 54 20.644z"
                transform="translate(-920 -1240) translate(920 1240) translate(4 7)"
              />
              <g fill="#231F20">
                <path
                  d="M10 17.318v12c0 2.206-1.794 4-4 4s-4-1.794-4-4V13.954H0v15.364c0 3.314 2.687 6 6 6s6-2.686 6-6v-12h-2z"
                  transform="translate(-920 -1240) translate(920 1240) translate(4 7) translate(50 29)"
                />
                <path
                  d="M12 18.682v-12c0-2.206 1.794-4 4-4s4 1.794 4 4v8.686h2V6.682c0-3.314-2.687-6-6-6s-6 2.686-6 6v12h2z"
                  transform="translate(-920 -1240) translate(920 1240) translate(4 7) translate(50 29)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
